export const TARGET_SETUP_ENDPOINTS = {
  FRAMEWORKS: "/frameworks",
  MASTER_DATA_DISCLOSURES: "/esg-master-data/disclosures",
  BY_DISCLOSURE: (disclosureId, year) =>
    `/target-setup/by-disclosure?disclosureId=${disclosureId}&year=${year}`,
  EXPORT_SUMMARY: "/target-setup/export/summary",
  EXPORT: "/target-setup/export",
  TARGET_SETUP: (id) => `/target-setup${id ? `/${id}` : ""}`,
  FREQUENCY: "/target-setup/frequency",
  BULK: "/target-setup/bulk",
};
